<template>
  <ValidationObserver ref="validationObserver" v-slot="{ errors }" class="w-full flex flex-col justify-start">
    <FormInput
      v-model="config.account_id"
      :readonly="forUser"
      :label="$t('projects.data_adapters.account_id')"
      name="account_id"
      :error="errors.account_id"
      :rules="['required']"
      class="mt-3"
      @update:modelValue="emitPayload"
    />
    <FormInput
      v-model="config.api_token"
      :readonly="forUser"
      :label="$t('projects.data_adapters.api_token')"
      name="api_token"
      :error="errors.api_token"
      :rules="['required']"
      class="mt-3"
      @update:modelValue="emitPayload"
    />

    <FormInput v-if="config.api_token === '*****'" v-model="config.database_name" readonly :label="$t('projects.data_adapters.database')" class="mt-3" />
    <FormSelect
      v-else
      v-model="config.database_id"
      :label="$t('projects.data_adapters.database')"
      name="database"
      :error="errors.database"
      :loading="databaseListFetching"
      :options="databases"
      :rules="['required']"
      class="mt-3"
      default-reducer
      append-to-body
      @update:modelValue="onDatabaseChange"
      @open="fetchDatabaseList"
    />
  </ValidationObserver>
</template>

<script>
import { apiGetProjectDataAdapterDatabases } from '@/helpers/api';
import { mapActions } from 'vuex';
import { DATA_ADAPTERS } from '../../constants';

export default {
  name: 'CloudflareD1Configuration',
  props: {
    defaultConfig: Object,
    forUser: Boolean,
  },
  data() {
    return {
      databaseListFetching: false,
      databases: [],
      editingDatabase: false,
      config: {
        enabled: true,
        account_id: '',
        api_token: '',
        database_id: '',
        database_name: '',
      },
    };
  },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    ...mapActions(['showToastMessage']),
    onDatabaseChange(database_id) {
      const item = this.databases.find((db) => db.value === database_id);
      this.config.database_name = item.label;
      this.emitPayload();
    },
    validate() {
      return this.$refs.validationObserver.validate();
    },
    emitPayload() {
      this.$emit('update:defaultConfig', this.config);
    },
    async fetchDatabaseList() {
      this.databaseListFetching = true;
      if (!this.config.api_token || !this.config.account_id) {
        this.databaseListFetching = false;
        return;
      }
      try {
        const response = await apiGetProjectDataAdapterDatabases({ project_id: this.projectId, adapter_type: DATA_ADAPTERS.CLOUDFLARE_D1.key, config: this.config });
        if (response.status === 200 && response.data) {
          this.databases = response.data.map((db) => ({ label: db.database_name, value: db.database_id }));
        } else {
          if (this.config.database_id && this.config.database_name) {
            this.databases = [{ label: this.config.database_name, value: this.config.database_id }];
          } else {
            this.databases = [];
          }
          this.showToastMessage({ message: response.data.message || this.$t('projects.data_adapters.database_fetch_error'), type: 'error' });
        }
      } catch (e) {
        if (this.config.database_id && this.config.database_name) {
          this.databases = [{ label: this.config.database_name, value: this.config.database_id }];
        } else {
          this.databases = [];
        }
        this.showToastMessage({ message: this.$t('projects.data_adapters.database_fetch_error'), type: 'error' });
      }
      this.databaseListFetching = false;
    },
  },
  watch: {
    defaultConfig: {
      handler() {
        if (this.defaultConfig) {
          this.config = { ...this.config, ...this.defaultConfig };

          if (this.config.database_id && this.config.database_name) {
            this.databases = [{ label: this.config.database_name, value: this.config.database_id }];
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss"></style>
